function lazythrottle(fn, delay) {
    var last = undefined;
    var timer = undefined;

    return function () {
        var now = +new Date();
        if (last && now < last + delay) {
        clearTimeout(timer);
        timer = setTimeout(function () {
            last = now;
            fn();
        }, delay);
        } else {
        last = now;
        fn();
        }
    };
}

function lazyloadTrustpilot() {

    var trustpilot_loaded = false;
    var widgets = document.querySelectorAll('.trustpilot-widget');

    // window.addEventListener('scroll', function (event) {
    window.addEventListener('scroll', lazythrottle(trustpilotScroll, 25));
    function trustpilotScroll() {
        widgets.forEach(function(widget){
        if (isInViewport(widget) && !trustpilot_loaded) {
            
            trustpilot_loaded = true;
            loadScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
        }
        });
    }
    // , false);

    var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
    };

    var loadScript = function (scriptUrl) {
    var script = document.createElement('script');
    script.src = scriptUrl;
    document.head.appendChild(script);
    }
}

export default lazyloadTrustpilot;